module.exports = __webpack_public_path__ + "fonts/Montserrat-ExtraBoldItalic.026abe49.ttf";